'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hr_HR = require('../../date-picker/locale/hr_HR');

var _hr_HR2 = _interopRequireDefault(_hr_HR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _hr_HR2['default'];